export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
  },
  {
    title: that.$l('table_label_displayImage') || '图片',
    field: 'displayImage',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_masterNcNo') || '成品编码',
    field: 'masterNcNo',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ncNo') || '子件编码',
    field: 'ncNo',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_goodsName') || '产品名称',
    field: 'goodsName',
    minWidth: 260,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_goodsSpec') || '产品尺寸',
    field: 'goodsSpec',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ row }) => [row.spec, row.specUnit].filter(Boolean).join(' '),
  },
  {
    title: that.$l('table_label_goodsColor') || '产品颜色',
    field: 'goodsColor',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_factoryOrderNo') || '工厂订单编号',
    field: 'factoryOrderNo',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_authorBy') || '业务人员',
    field: 'authorByName',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
]
